<table mat-table [dataSource]="dataSource" matSort>


  <ng-container matColumnDef="bezeichnung">
    <th mat-header-cell *matHeaderCellDef> {{ 'pages.zeitverwaltung.spesenverwaltung.table.bezeichnung' | translate }} </th>
    <td mat-cell *matCellDef="let rolle"> {{rolle.key }} </td>
  </ng-container>


  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td  class="smallField" mat-cell *matCellDef="let rolle" >
      <button class="action-menu-button" mat-icon-button [matMenuTriggerFor]="actionMenu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #actionMenu="matMenu">
        <button *ngIf="rolle.disabled == 0"  mat-menu-item (click)="editRolle(rolle)">{{ 'pages.zeitverwaltung.actions.edit' | translate }}</button>
        <button *ngIf="rolle.disabled == 0" mat-menu-item (click)="deleteRolle(rolle)">{{ 'pages.zeitverwaltung.actions.delete' | translate }}</button>
        <button *ngIf="rolle.disabled == 1"  mat-menu-item >Keine Funktionen verfügbar</button>
      </mat-menu>
    </td>
  </ng-container>

  <tr mat-header-row class="header-table-row" *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row class="table-row" *matRowDef="let myRowData; columns: displayedColumns"></tr>
</table>
